import { PaymentServiceType } from '@dni-types/data-models/ecommerce-payment'
import { PAYMENT_ERROR_CODE, PaymentError } from './PaymentError'
import { type PaymentModule, type PaymentSetting } from './types'
import { isTappaySdkLoaded, loadTappayScript } from './utilities'

export class TappayJkoPayModule implements PaymentModule<PaymentSetting> {
  isLoaded = false
  isInitialized = false
  appEnv: PaymentSetting['appEnv'] = 'sandbox'
  appId: Required<PaymentSetting>['appId'] = ''
  appKey: Required<PaymentSetting>['appKey'] = ''

  public loadScript = () => loadTappayScript().then(() => {
    this.isLoaded = true
  })

  public configurePayment(details: PaymentSetting) {
    console.debug('[Tappay Jko] configurePayment details:', details)
    if (!isTappaySdkLoaded(window.TPDirect)) return
    if (!details.appKey || !details.appId) {
      throw new PaymentError('[Tappay Jko] appKey or appId is required', PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.INVALID_APP_ID_OR_APP_KEY)
    }

    this.appEnv = details.appEnv
    this.appId = details.appId
    this.appKey = details.appKey

    try {
      window.TPDirect.setupSDK(this.appId, this.appKey, this.appEnv)
    }
    catch (error) {
      throw new PaymentError(`[Tappay Jko] Configuration failed: ${error}`, PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.CONFIGURATION_FAILED, error)
    }
  }

  public getPrime(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!isTappaySdkLoaded(window.TPDirect)) return
      try {
        window.TPDirect.jkoPay.getPrime((result) => {
          console.debug('[Tappay Jko] getPrime result:', result)
          if (result.prime) {
            resolve(result.prime)
          }
          else {
            reject(new PaymentError('[Tappay Jko] get prime failed', PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.INVALID_PRIME))
          }
        })
      }
      catch (error) {
        reject(new PaymentError(`[Tappay Jko] Failed to get prime: ${error}`, PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.GET_PRIME_ERROR, error))
      }
    })
  }
}
